<template>
  <div class="page performance">
    <page-banner
      title="演艺介绍"
      eyebrow="XI'AN CULTURE"
      subtitle="长恨歌、驼铃传奇、千古情三大王牌演艺，丝路欢乐世界与精品一日游"
    />
    <div class="page-body" v-loading="loading">
      <template v-if="groupedShows.length">
        <div v-for="group in groupedShows" :key="group.name" class="section-block">
          <div class="section-head">
            <h2>{{ group.name }}</h2>
          </div>
          <el-row :gutter="24">
            <el-col
              v-for="(item, index) in group.items"
              :key="item.id"
              :xs="24"
              :sm="12"
              :lg="8"
            >
              <performance-card :item="item" :color-index="index" />
            </el-col>
          </el-row>
        </div>
        <div v-if="total > query.pageSize" class="pagination-wrap">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="query.pageSize"
            :current-page.sync="query.pageNum"
            @current-change="loadPerformances"
          />
        </div>
      </template>
      <div v-else-if="!loading" class="page-empty">
        <i class="el-icon-film" />
        <p>暂无演艺内容</p>
      </div>
    </div>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue';
import PerformanceCard from '@/components/PerformanceCard.vue';
import { listPerformance } from '@/api/performance';

export default {
  name: 'Performance',
  components: { PageBanner, PerformanceCard },
  data() {
    return {
      loading: false,
      shows: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 12
      }
    };
  },
  computed: {
    groupedShows() {
      const map = {};
      this.shows.forEach(item => {
        const name = item.category || '精彩推荐';
        if (!map[name]) map[name] = [];
        map[name].push(item);
      });
      return Object.keys(map).map(name => ({ name, items: map[name] }));
    }
  },
  created() {
    this.loadPerformances();
  },
  methods: {
    loadPerformances() {
      this.loading = true;
      listPerformance(this.query)
        .then(res => {
          this.shows = res.rows || [];
          this.total = res.total || 0;
        })
        .catch(() => {
          this.shows = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.pagination-wrap {
  margin-top: 16px;
  text-align: center;
}
.page-empty i {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
  color: #dcdfe6;
}
</style>
